// extracted by mini-css-extract-plugin
export default {"container":"Vq_wm","filters":"cixRG","collection":"iMPrg","grid":"pHrSj","warning":"Om2dS","slider":"JdhN5","slide":"XZmF2","cnSlide":"TdKbk","video":"wnIcO"};